<template>
  <div>
    <div class="leftInfo">
      <div class="flex">
        <div>
          <img class="userPhoto"
                       :src="this.$store.state.m_user.userInfo.userphoto"
                       v-if="this.$store.state.m_user.userInfo.userphoto !== null"
                       alt="安徽继续教育网">
                  <img class="userPhoto"
                       src="../../assets/images/noUser.png"
                       v-else
                       alt="安徽继续教育网">
        </div>
      </div>
      <div class="userNameBox" style="text-align: center">
        {{ this.$store.state.m_user.userInfo.realname }}
      </div>
      <div class="flex">
        <div class="zhye" v-if="this.$store.state.m_user.userInfo.isMember !== '02'">账户余额：{{ this.$store.state.m_user.userInfo.balance || 0 }}</div>
        <div class="zhye" v-else>年度会员</div>
      </div>
    </div>

    <div class="tabBox">
      <div :class="tabIndex == 1 ? 'optionBox active' : 'optionBox'" @click="nav(1)">
        <img v-if="tabIndex == 1" src="../../assets/images/zaixue1.png" alt="安徽继续教育网" />
        <img v-else src="../../assets/images/zaixue.png" alt="安徽继续教育网" />
        继续教育
      </div>
      <div :class="tabIndex == 8 ? 'optionBox active' : 'optionBox'" @click="nav(8)">
        <img v-if="tabIndex == 8" src="../../assets/images/zsslh.png" alt="安徽继续教育网" />
        <img v-else src="../../assets/images/zssl.png" alt="安徽继续教育网" />
        职业培训
      </div>

      <!-- <div v-if="examShow">
                <div :class="tabIndex == 7  && examShow ? 'optionBox active' : 'optionBox'"
                     @click="nav(7)">
                  <img v-if="tabIndex == 7"
                       src="../../assets/images/exam1.png"
                       alt="安徽继续教育网">
                  <img v-else
                       src="../../assets/images/exam.png"
                       alt="安徽继续教育网">
                  我的考试
                </div>
              </div> -->

      <div :class="tabIndex == 3 ? 'optionBox active' : 'optionBox'" @click="nav(3)">
        <img v-if="tabIndex == 3" src="../../assets/images/dingdan1.png" alt="安徽继续教育网" />
        <img v-else src="../../assets/images/dingdan.png" alt="安徽继续教育网" />
        订单管理
      </div>

      <div :class="tabIndex == 4 ? 'optionBox active' : 'optionBox'" @click="nav(4)">
        <img v-if="tabIndex == 4" src="../../assets/images/zhanghao1.png" alt="安徽继续教育网" />
        <img v-else src="../../assets/images/zhanghao.png" alt="安徽继续教育网" />
        账号管理
      </div>

      <div :class="tabIndex == 5 ? 'optionBox active' : 'optionBox'" @click="nav(5)">
        <img v-if="tabIndex == 5" src="../../assets/images/chankan1.png" alt="安徽继续教育网" />
        <img v-else src="../../assets/images/chakan.png" alt="安徽继续教育网" />
        证书查看
      </div>

      <!-- <div :class="tabIndex == 6? 'optionBox active' : 'optionBox'"
                   @click="nav(6)">
                <img v-if="tabIndex ==6"
                     src="../../assets/images/zsslh.png"
                     alt="安徽继续教育网">
                <img v-else
                     src="../../assets/images/zssl.png"
                     alt="安徽继续教育网">
                证书申领
              </div> -->

      <div :class="tabIndex == 2 ? 'optionBox active' : 'optionBox'" @click="nav(2)">
        <img v-if="tabIndex == 2" src="../../assets/images/suoyou1.png" alt="安徽继续教育网" />
        <img v-else src="../../assets/images/suoyou.png" alt="安徽继续教育网" />
        会员权益
      </div>
       <div :class="tabIndex == 9 ? 'optionBox active' : 'optionBox'" @click="nav(9)">
        <img v-if="tabIndex == 9" src="../../assets/images/jifen.svg" alt="安徽继续教育网" />
        <img v-else src="../../assets/images/suoyou.png" alt="安徽继续教育网" />
        我的积分
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      tabIndex:'1'
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    nav(id) {
      console.log(id);
      window.location.replace('https://www.ahsjxjy.com/studyMain'+'?token='+ localStorage.getItem('token')+'&tabIndex='+id);
      
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.flex {
  display: flex;
  justify-content: center;
}
.userPhoto {
  width: 64px;
  height: 64px;
  border-radius: 50%;
}
.userNameBox {
  margin-top: 8px;
  font-size: 16px;
  color: #000;
}
.zhye {
  width: 150px;
  height: 42px;
  background: #fdf3e7;
  border-radius: 21px 21px 21px 21px;
  font-size: 14px;
  color: #ef8733;
  margin-top: 12px;
  text-align: center;
  line-height: 42px;
}
.leftInfo {
  width: 190px;
  height: 190px;
  background: #ffffff;
  margin-right: 10px;
  padding: 20px;
}

.fwhBox {
  margin-top: 10px;
  width: 190px;
  height: 210px;
  background: #ffffff;
  padding: 20px 25px;
  .f1 {
    color: #4076f6;
    font-size: 16px;
    text-align: center;
  }
  .fwh {
    width: 140px;
    height: 140px;
  }
}

.tabBox {
  margin-top: 12px;
  width: 190px;
  background: #ffffff;
  border-radius: 6px;
  box-sizing: border-box;
  padding: 36px 18px 20px 22px;
  font-size: 16px;
  .optionBox {
    width: 154px;
    height: 50px;
    border-radius: 6px;
    line-height: 50px;
    margin-bottom: 20px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 14px;
      height: 14px;
      margin-right: 5px;
    }
  }
  .active {
    color: #ffffff !important;
    background: #2878ff;
  }
}
</style>
